import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogBody,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { json } from "@codemirror/lang-json";
import CodeMirror from "@uiw/react-codemirror";

export default JsonEditorDialog;

function JsonEditorDialog({ open, onClose, value, onSave }) {
  const [draft, setDraft] = useState(value ?? "");
  const [error, setError] = useState(null);

  const handleSave = () => {
    try {
      JSON.parse(draft);
      setError(null);
      onSave(JSON.parse(draft));
      onClose();
    } catch {
      setError("Invalid JSON");
    }
  };

  return (
    <Dialog
      size="2xl"
      open={open}
      onClose={onClose}
    >
      <DialogTitle>Edit Body</DialogTitle>
      <DialogBody>
        {error && <p className="text-sm text-red-500 mb-2">{error}</p>}
        <CodeMirror
          value={draft}
          onChange={setDraft}
          extensions={[json()]}
          height="320px"
          theme="light"
          basicSetup={{
            lineNumbers: true,
            bracketMatching: true,
            closeBrackets: true,
          }}
        />
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}
